export interface MapViewOrgResolutionBank {
  idOrganization?: string;
}

/**
 * Resolves which single organisation's map data to fetch for Map View.
 *
 * Map View can only render one organisation's floor plan at a time, so when
 * the current bank selection spans more than one organisation (or none),
 * the caller should show the "multiple organisations" state instead.
 *
 * This derives the organisation purely from what is currently selected — it
 * never re-derives which organisations the user is allowed to see. Which
 * organisations a user may select from is decided by the server (see the
 * cross-org grant design); this helper only decides which single one of
 * those already-authorized selections Map View can display.
 */
export const resolveMapViewOrganizationId = (banks: MapViewOrgResolutionBank[]): string | null => {
  const orgIds = banks
    .map((bank) => bank.idOrganization)
    .filter(
      (value, index, self): value is string => Boolean(value) && self.indexOf(value) === index,
    );
  return orgIds.length === 1 ? orgIds[0] : null;
};
